import React from "react";
import { useTheme } from "@fluentui/react";
import { Input, InputProps } from "@fluentui/react-components";
import { usePcpInputStyles } from "./baseComponents.styles";


export const PcpInput = (props: InputProps): JSX.Element => {
    const theme = useTheme();
    const styles = usePcpInputStyles();

    return (
        <Input
            {...props}
            root={{ className: styles.root }}
            input={{ className: styles.input }}
        />
    )
};
